/**
 * Thrown from a report's `reportFn` when execution should stop and the user
 * should see `message` in the error toast (see `useReport`).
 */
export class ReportError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ReportError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
